import { Slide } from "react-reveal";

const WebsiteDevelopmentOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    We don't use templates. We code clients' websites from
                    scratch following industry's best practices to ensure
                    maximum performance, control and security.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>Setup & Infrastructure</h3>
                      <ul>
                        <li>
                          <span>Domain Name</span>
                        </li>
                        <li>
                          <span>Hosting(High-performace servers)</span>
                        </li>
                        <li>
                          <span>
                            SSL Certificate(For a secure & encrypted website)
                          </span>
                        </li>
                        <li>
                          <span>Professional business emails</span>
                        </li>
                        <li>
                          <span>Website backup & recovery setup</span>
                        </li>
                        <li>
                          <span>CDN & performance optimization setup</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Design & Development</h3>
                      <ul>
                        <li>
                          <span>
                            Custom website(No Templates or CMS limitations)
                          </span>
                        </li>
                        <li>
                          <span>
                            Responsive Design (Mobile, Tablet & Desktop)
                          </span>
                        </li>
                        <li>
                          <span>
                            UI/UX Optimization for better use experience
                          </span>
                        </li>
                        <li>
                          <span>Contact Forms & Payments Integrations</span>
                        </li>
                        <li>
                          <span>Social media integration (Whatsapp Chat)</span>
                        </li>
                        <li>
                          <span>Chatbots & AI integrations</span>
                        </li>
                        <li>
                          <span>Unlimited pages</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Growth & Optimization</h3>
                      <ul>
                        <li>
                          <span>Search Engine Optimization</span>
                        </li>
                        <li>
                          <span>Google Analytics Integration</span>
                        </li>
                        <li>
                          <span>Google Maps Integration</span>
                        </li>
                        <li>
                          <span>Google Business Profile Setup</span>
                        </li>
                        <li>
                          <span>Speed Optimizations (Core Web Vitals)</span>
                        </li>
                        <li>
                          <span>
                            On-page SEO setup (Meta tags, Sitemap & Indexing)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Branding & Content</h3>
                      <ul>
                        <li>
                          <span>Content Copywriting</span>
                        </li>
                        <li>
                          <span>Logo design or redesign</span>
                        </li>
                        <li>
                          <span>Tagline composition</span>
                        </li>
                        <li>
                          <span>Image editing & optimization</span>
                        </li>
                        <li>
                          <span>Content guidance & advisory</span>
                        </li>
                        <li>
                          <span>Brand guidance & advisory</span>
                        </li>
                      </ul>
                    </li>

                    <li className="offers-list">
                      <h3>Support, Delivery & Training</h3>
                      <ul>
                        <li>
                          <span>Fast Delivery (From 3 days)</span>
                        </li>
                        <li>
                          <span>Updating & Maintenance (Free 3 months)</span>
                        </li>
                        <li>
                          <span>Admin Access (If required)</span>
                        </li>
                        <li>
                          <span>Basic website management training</span>
                        </li>
                        <li>
                          <span>Ongoing technical support</span>
                        </li>
                        <li>
                          <span>Ongoing branding support</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Security & Reliability</h3>
                      <ul>
                        <li>
                          <span>Spam protection & guidance</span>
                        </li>
                        <li>
                          <span>Website security hardening</span>
                        </li>
                        <li>
                          <span>Ongoing security monitoring</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebsiteDevelopmentOffers;
